/**
 * Control Center header "N users" badge (Paul GO Oct 25): real current users =
 * Stripe-truth paying + trials whose trial_ends_at is still ahead.
 * Mycelium /api/admin/panel/dashboard/stats returns `headerUsers: { paying, trialing, total }`.
 */
export type DashboardStatsForBadge = {
  headerUsers?: { paying?: number; trialing?: number | null; total?: number } | null;
  activeSubscribers?: number;
  trialUsers?: number;
} | null | undefined;

export type HeaderUsersBadge = { count: number; title: string };

export function headerUsersBadge(d: DashboardStatsForBadge): HeaderUsersBadge | null {
  if (!d) return null;
  const hu = d.headerUsers;
  if (hu && typeof hu.paying === 'number') {
    if (typeof hu.trialing === 'number') {
      return { count: hu.paying + hu.trialing, title: `${hu.paying} paying · ${hu.trialing} on trial` };
    }
    return { count: hu.paying, title: `${hu.paying} paying (trial count refreshing)` };
  }
  // Older API without headerUsers: previous tier-count sum until the backend ships.
  const paying = d.activeSubscribers ?? 0;
  const trial = d.trialUsers ?? 0;
  return { count: paying + trial, title: `${paying} active tier · ${trial} trial tier` };
}
